<template>
    <div>
        <vs-table :noDataText="$t('no_data_text')" ref="table" :data="CANCELLATION_HISTORY">
            <template slot="thead">
                <vs-th sort-key="created">{{  $t("created")  }}</vs-th>
                <vs-th sort-key="changed_by">{{  $t("changed_by")  }}</vs-th>
                <vs-th sort-key="date">{{  $t("date")  }}</vs-th>
                <vs-th sort-key="canceled">{{  $t("cancelled")  }}</vs-th>
                <vs-th sort-key="comment">{{  $t("Comment")  }}</vs-th>


            </template>
            <template slot-scope="{ data }">
                <tbody>
                <vs-tr  v-for="(item, indextr) in data" :key="indextr" :data="item">
                    <vs-td><p> {{ $moment(item.created).format('DD.MM.YYYY H:mm:ss') }} </p></vs-td>
                    <vs-td><p> {{ item.changed_by }} </p></vs-td>
                    <vs-td><p> {{ item.date }} </p></vs-td>
                    <vs-td><p> {{ translateBool(item.canceled) }} </p></vs-td>
                    <vs-td><p> {{ item.comment }} </p></vs-td>

                </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "CancellationHistory",
    computed:{
        ...mapGetters({
            CANCELLATION_HISTORY: 'electronic_journal/CANCELLATION_HISTORY'
        })

    },
    methods:{
        translateBool(bool) {
            if (bool) return  this.$t('Yes')
            else return this.$t('No')
        },
    }
};
</script>

<style scoped>

</style>
